<div class="container main-layout">
    <div class="right-container">
        <div class="left-titl-buton ">
            <div class="back-button" (click)="backbutton()">
                &larr;
            </div>
            <div class="title">{{first_name}}'s Roleplay 
                <!-- <div class="scenario-name">
                        <span class="tag" *ngIf="chatType === 'role-play'">(Score Session)</span>
                        <span class="tag" *ngIf="chatType === 'role-play-practice '">(Practice Session)</span>
                </div> -->
                 <span class="scenario-name" title="{{scenarioName}}"> - {{scenarioName | truncate:15}} </span>

                <div class="title-objectives"><img src="../../../assets/images/info-icon.svg" alt=""><span class="objName">Summary</span>
                    <div class="roleplay-tooltip">
                        <span>Summary of Roleplay</span>
                        <ul *ngIf="items">
                            <li *ngFor="let ele of items">{{ele.objectives}}</li>
                        </ul>
                        <ul *ngIf="!items">
                            <li>NA</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="title">Assigned Roleplay Chat - <span class="scenario-name">{{roleplayInfo?.scenario_name}}</span> 
            <div class="title-objectives"><span class="dot">...</span><span>Objectives</span>
                <div class="roleplay-tooltip">
                    <span>Objectives of Roleplay</span>
                    <ul *ngIf="roleplayInfo.objectives">
                        <li *ngFor="let item of roleplayInfo.objectives">{{item}}</li>
                    </ul>
                    <ul *ngIf="!roleplayInfo.objectives">
                        <li>NA</li>
                    </ul>
                </div>
            </div>
        </div> -->

        <div class="chat-window">
            <div class="frame-box" id="chat-box">
                <div *ngFor="let item of conversation">
                    <div class="card-text padding" [ngClass]="item.cssClass">
                        <div class="right-side">
                            <div class="profile-container-ai">
                                <img class="profile-img" src="../../../assets/images/JJ_Icon_Person_RGB (3).svg"
                                    alt="Profile Image" title="Ai chat">
                            </div>
                            <div class="bubble question-bubble">
                                <div class="time">
                                    <span class="date-time profile-name"><span> {{first_name}} </span>at {{item.request_time | date: 'hh:mm MMM dd'}}</span>
                                </div>
                                <div class="typewriter1">
                                    <p>{{ item.question}}</p>
                                </div>
                            </div>
                            <div id="loader" class="loader"></div>
                        </div>
                        <div class="left-side">
                            <div class="profile-container">
                                <img class="profile-img" src="../../../assets/images/chatbot-icon.svg"
                                    alt="Profile Image" title="Ai chat">
                            </div>
                            <div class="bubble answer-bubble-ans">
                                <div class="time-ans">
                                    <span class="date-time profile-name"><span> {{DrName}} </span>at    {{item.response_time | date: 'hh:mm MMM dd'}}</span>
                                </div>
                                <div class="typewriter">
                                    <p>{{ item.answer }}</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div id="feedback-footer">
                    <div class="message-box">
                        <span>Enter Feedback for trainee</span>
                    </div>
                    <div class="bubble feedback-bubble">
                        <div class="typewriter-feed">
                           <!--  <h4 *ngIf="!editEnabled && !feedbackData">You have completed the Roleplay session! Your
                                score is {{score}}%</h4> -->
                                <h4 *ngIf="!editEnabled && !feedbackData">{{feedbackData}}</h4>
                            <h4 *ngIf="!editEnabled && feedbackData">{{ feedbackData }}</h4>

                            <textarea *ngIf="editEnabled" class="form-control" [(ngModel)]="feedbackData">
                                </textarea>
                        </div>
                        <div class="button-div">
                            <button [ngClass]="{
                                'clear': editEnabled,
                                'error': !editEnabled
                              }" (click)="enableEdit()" type="button">Edit</button>

                            <button [ngClass]="{
                                'error': editEnabled,
                                'clear': !editEnabled
                              }" type="button" [disabled]="!editEnabled"
                                (click)="submitFeedback()">Submit</button>
                        </div>
                    </div>
                </div>
                <div>

                    <div id="loader" class="loader"></div>
                    <div class="overlay-content">
                        <div class="overlay-content-top" *ngIf="showOverlay">
                            <div class="trending-topic-icon">
                                <img src="../../../assets/images/overlay-content-icon.svg" alt="Trending Topics" />
                            </div>
                            <div class="label">
                                <span>Hi {{givenName}}!</span>
                                <span>Please start the {{this.config.RolePlay.DisplayText}} for selected scenario.</span>
                            </div>
                        </div>

                    </div>

                </div>

            </div>
            <div class="prompt">
                <div class="footer-input col-md-10" id="input-footer">
                    <div class="input-block">
                        <!-- <img class="input-icon-before" src="../../../assets/images/chat-before-icon.svg" alt="Prompt" /> -->
                        <textarea [(ngModel)]="userAnswer" (keyup.enter)="getNextQuestion()" class="form-control"
                            placeholder="Click mic or type your answer here...." rows="3" autofocus></textarea>
                        <img src="../../../assets/images/chat-after-icon.svg" alt="Icon" class="input-icon"
                            [class.disabled]="!userAnswer" (click)="getNextQuestion()">
                    </div>
                    <div class="disclaimer-div">
                        <span class="disclaimer">*aiadvisor can make mistakes. Consider checking the important
                            information.​</span>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>